<template>
  <b-container>
    <b-row class="ja-decoration">
    </b-row>
    <b-form @submit.prevent="register()">
      <b-row>
        <b-col cols="12">
          <b-col cols="12" class="mt-1 title" tabindex="1">{{ $t("register_register") }}</b-col>
          <b-col cols="12" class="mt-3">
            <label for="email" class="semi-bold purple-text">{{ $t("register_label_email") }}</label>
            <input id="email" class="input-register" placeholder="name@domain.com" type="text"
                   v-model="form.email" value="" tabindex="2">
            <span v-if="emailError" class="form-error">{{ $t("error_required_field") }}</span>
            <ul class="error-content ">
              <li class="error-text" v-for="error in emailErrors" v-bind:key="error">{{ error }}</li>
            </ul>
          </b-col>
          <b-col cols="12 mt-4">
            <label for="password" class="semi-bold purple-text">{{ $t("password") }}</label>
            <input id="password" class="input-register" :placeholder="$t('password_placeholder')" type="password"
                   v-model="form.password" value="" tabindex="3">
            <span v-if="passwordError" class="form-error">{{ $t("error_required_field") }}</span>
            <ul class="error-content">
              <li class="error-text" v-for="error in passwordErrors" v-bind:key="error">{{ error }}</li>
            </ul>
          </b-col>
          <b-col cols="12 mt-4">
            <label for="confirm-password" class="semi-bold purple-text">{{ $t("register_confirm_password") }}</label>
            <input id="confirm-password" class="input-register" :placeholder="$t('password_placeholder')"
                   type="password" v-model="form.confirmPassword" value="" tabindex="4">
            <span v-if="confirmPasswordError" class="form-error">{{ confirmPasswordError }}</span>
          </b-col>
          <legal-warning :button="$t('register_create_account')" :show-date="false"/>
          <b-col cols="12" class="mt-4">
            <b-button block variant="primary" class="button-text" type="submit" tabindex="5" :disabled="isDisabled">
              {{ $t("register_create_account") }}
            </b-button>
          </b-col>
        </b-col>
        <b-col cols="12" class="mt-3 mb-4 text-center">
          <router-link :to="{ name: 'Login' }" tabindex="6">
            <span class="semi-bold black-text"> {{ $t("already_have_account") }} </span>
            <span class="semi-bold purple-text"> {{ $t("login") }}</span>
          </router-link>
        </b-col>
      </b-row>
    </b-form>
    <legal-message />
    <children-privacy-protection/>
  </b-container>
</template>

<script>
import {UserService} from '../Services'
import LegalWarning from "../Components/LegalWarning"
import LegalMessage from "../Components/LegalMessage"
import ChildrenPrivacyProtection from "../Components/ChildrenPrivacyProtection"
import validateForms from '../../../core/Mixins/validate-forms'


export default {
  name: 'Register',
  components: {LegalWarning, LegalMessage, ChildrenPrivacyProtection},
  mixins: [validateForms],
  data() {
    return {
      form: {email: "", password: "", confirmPassword: ""},
      emailError: false,
      passwordError: false,
      confirmPasswordError: "",
      emailErrors: [],
      passwordErrors: [],
      serviceError: false,
      isDisabled: false,
    }
  },
  methods: {
    register() {
      const {email, password, confirmPassword} = this.form
      this.emailErrors = []
      this.passwordErrors = []
      this.serviceError = false
      this.emailError = email === ""
      this.passwordError = password === ""
      if (confirmPassword === "") this.confirmPasswordError =  this.$t("error_required_field")
      if (password !== confirmPassword) this.confirmPasswordError = this.$t("error_confirm_password_not_coincide")
      if (confirmPassword !== "" && password === confirmPassword) this.confirmPasswordError = ""

      if (email && password && confirmPassword && password === confirmPassword && this.isValidform()) {
        this.isDisabled = true

        UserService.registerUser(this.form).then(response => {
          if(response.parentConsentRequired){
            this.$router.push({ name: 'ParentConsentRequired', params: { userId: response.user.id } })
          }else{
            this.$router.push({name: 'VerifyEmail'})
          }
        }).catch(err => {
          this.isDisabled = false
          if (err) {
            if (err.message) {
              this.serviceError = err.message
            }
            if (err.errors) {
              if (err.errors['Password']) {
                err.errors['Password'].forEach(error => this.passwordErrors.push(this.$t(error)))
              }
              if (err.errors['Email']) {
                err.errors['Email'].forEach(error => this.emailErrors.push(this.$t(error)))
              }
            }
          }
        })
      }
    }
  }
}

</script>
<style scoped lang="stylus">
@import "../Styles/security_styles.styl"

.black-text
  font-family arial, sans-serif, Semibold

.input-register
  width: 100%
  border-radius: 8px

.button-text
  font font-opensans-cond

.title-register
  font font-roboto-bold
  font-size 40px
  color black
</style>
